/** 値が無いことを示す表示（一覧・詳細で共通）。 */
export const EMPTY_VALUE = "—";

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat("ja-JP", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

const DATE_FORMATTER = new Intl.DateTimeFormat("ja-JP", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function formatDateTime(date: Date | null): string {
  return date === null ? EMPTY_VALUE : DATE_TIME_FORMATTER.format(date);
}

export function formatDate(date: Date | null): string {
  return date === null ? EMPTY_VALUE : DATE_FORMATTER.format(date);
}

/** 金額の表示。metadata は文字列で来るため数値化できないものはそのまま返す。 */
export function formatCurrency(value: string | null): string {
  if (value === null) return EMPTY_VALUE;

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return value;

  return parsed.toLocaleString("ja-JP");
}
